module.exports = __webpack_public_path__ + "img/arrowUp.7a90da41.svg";